export default {
  lyft: {
    pink: '#EC2A9A'
  }
};
